// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__1aT0i","notEditable":"Switch_notEditable__3dv9J"};